import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"
import { show_error, show_success, showBlock } from "lib/helpers"

// application_settings/api_keys/index — data-controller="application-settings--api-keys--index"
export default class extends Controller {
  static targets = ["table", "newButton", "newModal", "newForm", "deleteModal", "deleteForm"]

  static values = {
    apiKeysPath: String,
  }

  connect() {
    if (!this.hasTableTarget) return
    this.#initDataTable()
    this.#bindNewApiKeyForm()
  }

  disconnect() {
    if (this.dataTable) {
      this.dataTable = destroyTurboDataTable(this.dataTable)
    }
    $(document).off(".apiKeys")
    $("#check-all").off(".apiKeys")
    if (this.hasNewFormTarget) $(this.newFormTarget).off(".apiKeys")
    if (this.hasDeleteFormTarget) $(this.deleteFormTarget).off(".apiKeys")
  }

  openNewModal(event) {
    event.preventDefault()
    $(this.newModalTarget).modal("show")
    $(this.newFormTarget).find("input[type='submit']").enable(true)
  }

  copyApiKey(event) {
    event.preventDefault()
    const apiKey = $(event.currentTarget).data("api-key")
    const tempTextArea = document.createElement("textarea")
    tempTextArea.value = apiKey
    document.body.appendChild(tempTextArea)
    tempTextArea.select()
    document.execCommand("copy")
    document.body.removeChild(tempTextArea)
  }

  showDeleteConfirmation(event) {
    event.preventDefault()

    const groupName = $("input#check-all").val()
    const checkboxes = $(`input[name^='${groupName}']:checked`)
    const available = $(`input[name^='${groupName}']`)

    if (!available.length) return
    if (!checkboxes.length) {
      alert("Please select at least one item")
      return
    }

    $(this.deleteModalTarget).modal("show")
    this.#bindDeleteConfirmation()
  }

  #bindNewApiKeyForm() {
    const $form = $(this.newFormTarget)
    $form.ajaxForm({
      dataType: "json",
      clearForm: true,
      resetForm: true,
      success: (response) => {
        $(this.newModalTarget).modal("hide")

        if (response.success) {
          show_success(response.message)
          this.dataTable.draw(false)
        } else {
          const error = $("#api-keys-errors")
          if (error.length === 1) error.after(error.clone())
          showBlock("#api-keys-errors", response.message)
        }
      },
      error: () => {
        showBlock("#api-keys-errors", "An error occurred during request")
      },
    })
  }

  #bindDeleteConfirmation() {
    const groupName = $("input#check-all").val()
    const checkboxes = $(`input[name^='${groupName}']:checked`)
    const ids = $.makeArray(checkboxes.map(function () { return $(this).val() }))

    const $form = $(this.deleteFormTarget)
    $form.off("submit.apiKeys")
    $form.ajaxForm({
      dataType: "json",
      method: "DELETE",
      data: { item_ids: ids },
      resetForm: true,
      success: (response) => {
        if (response.success) {
          $(this.deleteModalTarget).modal("hide")
          show_success("API key(s) has been successfully removed")
          this.dataTable.draw()
        } else {
          showBlock("#confirm-api-key-deletion-errors", response.message)
        }
        $form.find("input[type='submit']").enable(true)
      },
      error: () => {
        show_error("Unexpected error occurred during request")
      },
    })
  }

  #initDataTable() {
    const $table = $(this.tableTarget)

    this.dataTable = createTurboDataTable($table, {
      dom: 'l<"head-toolbar api-keys-header">rt<"F"ip<"toolbar">>',
      bSort: false,
      bPaginate: true,
      iDisplayLength: 10,
      stateSave: true,
      serverSide: true,
      processing: true,
      searchDelay: 2000,
      autoWidth: false,
      ordering: true,
      scrollX: true,
      order: [3, "asc"],
      ajax: { url: this.apiKeysPathValue || "api_keys" },
      initComplete: () => {
        $("#loading").hide()
        if ($("#reader").val() === "false") {
          $(".toolbar").html(
            `<br><br><a href="#" id="remove-api-keys" class="remove" data-action="click->application-settings--api-keys--index#showDeleteConfirmation">Remove selected</a>`,
          )
        }
        const $newButton = this.hasNewButtonTarget ? $(this.newButtonTarget) : $("#new-api-key-button")
        if ($newButton.length) {
          $(".api-keys-header").append($newButton.remove().removeClass("hide_button"))
        }
        this.#bindRowSelection()
      },
      drawCallback: () => {
        $(document).off("click.apiKeys", ".copy-api-key").on("click.apiKeys", ".copy-api-key", (e) => this.copyApiKey(e))
      },
      footerCallback: () => {
        $("#check-all").prop("checked", false)
      },
      columnDefs: [
        {
          targets: 0,
          createdCell: (cell, cellData) => {
            $(cell).html(
              `<input type="checkbox" class="table-checkbox-api-keys" id="check--keys${cellData}" name="item_ids[]" value="${cellData}"/> <label for="check--keys${cellData}"><label/>`,
            )
          },
          width: "10px",
        },
        {
          targets: 1,
          createdCell: (cell, cellData) => {
            $(cell).html(
              `<p class="copy-text copy-api-key" data-api-key="${cellData}">${cellData}</p><i class="copy-api-key bg-copy" data-api-key="${cellData}"/>`,
            )
          },
          width: "390px",
        },
        { targets: 3, width: "150px" },
        { targets: [0, 1, 2], searchable: false },
        { targets: [0, 1, 2], sortable: false },
      ],
    })
  }

  #bindRowSelection() {
    $("#check-all").on("change.apiKeys", function () {
      const isChecked = $(this).prop("checked")
      $(".table-checkbox-api-keys").prop("checked", isChecked)
      $(".table-checkbox-api-keys").closest("tr").toggleClass("selected-row", isChecked)
    })

    $(document).on("change.apiKeys", ".table-checkbox-api-keys", function () {
      const isChecked = $(this).prop("checked")
      $(this).closest("tr").toggleClass("selected-row", isChecked)
      const allChecked = $(".table-checkbox-api-keys:checked").length === $(".table-checkbox-api-keys").length
      $("#check-all").prop("checked", allChecked)
    })

    $(".table-checkbox").on("change.apiKeys", function () {
      const isChecked = $(this).prop("checked")
      $(".table-checkbox-api-keys").prop("checked", isChecked)
      $(".table-checkbox-api-keys").closest("tr").toggleClass("selected-row", isChecked)
    })
  }
}
